import styled, { css } from 'styled-components';
import colors from '../../helpers/colors';
import mediaQuery from '../../helpers/mediaQuery';
import spacing from '../../helpers/spacing';
import PageWidthContainer from '../PageWidthContainer';

export const FullWidthBackground = styled(PageWidthContainer)<{
  colouredBackground: boolean;
}>`
${(props) =>
  props.colouredBackground &&
  css`
    background-color: ${colors.neutral07};
  `}
  margin-top: ${spacing(4)};
  padding-top: ${spacing(6)};
  padding-bottom: ${spacing(6)};
  ${mediaQuery.tabletLandscape`
    padding-top: ${spacing(8)};
    padding-bottom: ${spacing(8)};
  `}
`;

export const DesktopOnlyDiv = styled.div`
  display: none;
  ${mediaQuery.tabletLandscape`
    display: flex;
  `}
`;

export const MobileOnlyDiv = styled.div`
  display: flex;
  ${mediaQuery.tabletLandscape`
    display: none;
  `}
`;
